import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[DurationPicker]',
})
export class DurationPickerDirective {
  private navigationKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', ':'];
  @Input()
  picker: HTMLInputElement;

  constructor(public el: ElementRef) {
    this.picker = el.nativeElement;
    this.picker.value = '00:00:00';
    this.picker.style.textAlign = 'right';
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(e: KeyboardEvent) {
    if (this.navigationKeys.indexOf(e.key) > -1) {
      // let it happen, don't do anything
      return;
    }
    if (e.key === ' ' || isNaN(Number(e.key))) {
      e.preventDefault();
    }
  }

  @HostListener('change', ['$event'])
  onChanges(e: { target: { value: string } }) {
    this.validateInput(e);
  }

  @HostListener('click', ['$event'])
  onClick(e: { target: { selectionStart: number; value: string | string[]; selectionEnd: any } }) {
    this.selectFocus(e);
  }

  validateInput(event: { target: { value: string } }) {
    const sectioned = event.target.value.split(':');
    if (sectioned.length !== 3) {
      event.target.value = '00:00:00'; // fallback to default
      return;
    }
    if (sectioned.length === 3 && sectioned[1].length === 0) {
      event.target.value = '00:00:00'; // fallback to default
      return;
    }
    if (sectioned.length === 3 && sectioned[0].length === 0) {
      event.target.value = '00:00:00'; // fallback to default
      return;
    }
    if (sectioned.length === 3 && sectioned[2].length === 0) {
      event.target.value = '00:00:00'; // fallback to default
      return;
    }

    const num0 = parseInt(sectioned[0], 10);
    const num1 = parseInt(sectioned[1], 10);
    const num2 = parseInt(sectioned[2], 10);

    if (isNaN(num0)) {
      sectioned[0] = '00';
    }
    if (isNaN(num1) || num1 < 0) {
      sectioned[1] = '00';
    }
    if (isNaN(num2) || num2 < 0) {
      sectioned[2] = '00';
    }
    if (num1 > 59 || sectioned[1].length > 2) {
      sectioned[1] = '59';
    }
    if (num2 > 59 || sectioned[2].length > 2) {
      sectioned[2] = '59';
    }
    event.target.value = sectioned.join(':');
  }

  selectFocus = (event: { target: { selectionStart: number; value: string | string[]; selectionEnd: any } }) => {
    // get cursor position and select nearest block;
    const cursorPosition = event.target.selectionStart;
    // '00:00' this is the format used to determine cursor location
    const hourMarker = event.target.value.indexOf(':');
    if (hourMarker < 0) {
      // something wrong with the format. just return;
      return;
    }
    if (cursorPosition < hourMarker) {
      event.target.selectionStart = 0; // hours mode
      event.target.selectionEnd = hourMarker;
    }
  };
}
